import { Component } from '@angular/core';

@Component({
  selector: 'icon-link',
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
        <path d="M10.5 7V10C10.5 10.2652 10.3946 10.5196 10.2071 10.7071C10.0196 10.8946 9.76522 11 9.5 11H2.5C2.23478 11 1.98043 10.8946 1.79289 10.7071C1.60536 10.5196 1.5 10.2652 1.5 10V3C1.5 2.73478 1.60536 2.48043 1.79289 2.29289C1.98043 2.10536 2.23478 2 2.5 2H5.5M10.5 2L6 6.5M10.5 2H7.5M10.5 2V5" stroke="#0C8080" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `,
  styles: `
    svg{
        cursor: pointer;
    }
  `
})

export class LinkIconComponent {}
